import linkedin from "../assets/linkedin_icon.svg";
import github from "../assets/github.svg";
import email from "../assets/mail.svg";

export const CONTACT_LINKS = [
  {
    id: 1,
    name: "linkedin",
    src: linkedin,
    path: "https://www.linkedin.com/in/sigal-shalit-manor"
  },
  { id: 2, name: "github", src: github, path: "https://github.com/Sigalsha" },
  {
    id: 3,
    name: "email",
    src: email,
    path: "mailto:sigal.shalit.manor@gmail.com"
  }
];
